import { Form } from "react-bootstrap";
import { entitySelectOptions } from "./crudInputModel";
import { RequiredAsterisks } from "../../Asterisks/requiredAsterisks";
import { EntitySelectField } from "../../../../fields/modules/commons/entitySelectField/entitySelectField";
import { z } from "zod";

export const CrudEntitySelectInput = ({
  validationSchema,
  form,
  name,
  label,
  t,
  required,
  entitySelectOptions,
  disabled,
}: entitySelectOptions) => {
  return (
    <form.Field
      key={name}
      name={name}
      validators={{
        onSubmit: validationSchema,
      }}
    >
      {(field) => {
        return (
          <Form.Group className="mb-3">
            <Form.Label>
              {label} {required && <RequiredAsterisks />}
            </Form.Label>
            <EntitySelectField
              id={field.name}
              name={field.name}
              onBlur={field.handleBlur}
              isInvalid={field.state.meta.errors.length > 0}
              value={field.state.value}
              onChange={(option) => {
                if (option === null) return;
                let value: string | number = (option as { value: string })
                  .value;

                if (value === form.getFieldValue(name)) return;

                if (validationSchema instanceof z.ZodNumber) {
                  value = parseInt(value);
                }

                field.handleChange(value);
              }}
              {...entitySelectOptions}
              isDisabledButLoadOptions={disabled}
            />

            {field.state.meta.errors && field.state.meta.errors[0] ? (
              <Form.Control.Feedback type="invalid">
                {t(field.state.meta.errors[0])}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
        );
      }}
    </form.Field>
  );
};
